import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api";

export const fetchProducts = createAsyncThunk(
  "product/fetchProducts",
  async (params = {}, { rejectWithValue }) => {
    try {
      const {
        page = 1,
        page_size = 100,
        category,
        color,
        size,
        min_price,
        max_price,
        ordering,
        search,
      } = params;

      const query = new URLSearchParams({
        page,
        page_size,
        ...(category ? { category } : {}),
        ...(color ? { color } : {}),
        ...(size ? { size } : {}),
        ...(min_price ? { min_price } : {}),
        ...(max_price ? { max_price } : {}),
        ...(ordering ? { ordering } : {}),
        ...(search ? { search } : {}),
      }).toString();

      const res = await api.get(`shop/products/?${query}`);
      return res.data.results || res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchProductDetail = createAsyncThunk(
  "product/fetchProductDetail",
  async (id, { rejectWithValue }) => {
    try {
      const res = await api.get(`shop/products/${id}/`);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const productSlice = createSlice({
  name: "product",
  initialState: {
    products: [],
    productDetail: null,
    loading: false,
    detailLoading: false,
    error: null,
  },
  reducers: {
    clearProductDetail: (state) => {
      state.productDetail = null;
      state.detailLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProducts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.products = action.payload;
      })
      .addCase(fetchProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchProductDetail.pending, (state) => {
        state.detailLoading = true;
        state.error = null;
      })
      .addCase(fetchProductDetail.fulfilled, (state, action) => {
        state.detailLoading = false;
        state.productDetail = action.payload;
      })
      .addCase(fetchProductDetail.rejected, (state, action) => {
        state.detailLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearProductDetail } = productSlice.actions;
export default productSlice.reducer;
